export function doLogin(data: any): Promise<unknown> {
    return new Promise((resolve: (...args: Array<unknown>) => void, reject: (error: Error) => void) =>
        $.ajax({
            type: "POST",
            contentType: "application/x-www-form-urlencoded",
            data: data,
            url: `/rest/publicLogin`
        }).done(() => {
            Promise.all(initializeListSession())
                .then(() => resolve())
                .catch((error: Error) => reject(error));
        }).fail((error: any) => reject(error)));
}

export function doLoginSso(): Promise<unknown> {
    return Promise.all(initializeListSession());
}

export function signinPublicUser(publicUser: any): JQueryPromise<unknown> {
    return $.ajax({
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(publicUser),
        url: `/rest/publicUser/registerUser`
    });
}

export function passwordRecovery(data: any): JQueryPromise<unknown> {
    return $.ajax({
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        url: "/rest/publicUser/sendResetPassword"
    });
}

export function doLogout(): JQueryPromise<unknown> {
    return $.ajax({
        type: "GET",
        url: `/rest/doLogout`
    });
}

export function resendConfirmationEmail(email: string): JQueryPromise<unknown> {
    return $.ajax({
        type: "POST",
        url: `/rest/publicUser/resendConfirmationMail/${email}`
    })
}

function initializeListSession(): Array<Promise<unknown>> {
    return [
        new Promise((resolve: (...args: Array<unknown>) => void, reject: (error: JQuery.jqXHR) => void) => {
            $.ajax({
                type: "GET",
                url: `/rest/publicUser/setExcludedIdListSession`
            }).done(() => resolve()).fail((error: JQuery.jqXHR) => reject(error));
        }),
        new Promise((resolve: (...args: Array<unknown>) => void, reject: (error: JQuery.jqXHR) => void) => {
            $.ajax({
                type: "GET",
                url: `/rest/publicUser/setFavouriteIdListSession`
            }).done(() => resolve()).fail((error: JQuery.jqXHR) => reject(error));
        })
    ];
}